var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAO0lEQVR42mMYBYMdPJWUPAPCZGteyMcHxiA2WZprOThAmHRDgIrdgVQaMi5jZ+8Cs0kAKtjERlMGDQAAtsAY2zWhA5wAAAAASUVORK5CYII=";
  export default img;